module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parcours-index"
  }, [_c('loader'), _vm._v(" "), (_vm.parcours && _vm.parcours.versions) ? _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.parcours.versions[0].title))])]), _vm._v(" "), _c('scroll-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "row scroll row--all"
  }, [_c('div', {
    staticClass: "col-md-11 col-md-offset-1"
  }, [_c('div', {
    staticClass: "vertical-list-container"
  }, [_c('div', {
    staticClass: "vertical-list-wrapper"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'parcoursAll'
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n                Retour aux parcours\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('h2', [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n                " + _vm._s(_vm.parcours.versions[0].title))])]), _vm._v(" "), _vm._l((_vm.parcours.entities), function(entity, index) {
    return _c('h3', [_c('router-link', {
      attrs: {
        "to": {
          name: 'parcoursSingle',
          params: {
            parcoursId: _vm.parcours.id_keyword,
            epigramIndex: index + 1
          }
        }
      }
    }, [_c('span', {
      staticClass: "bg"
    }), _vm._v(_vm._s(entity.title) + " "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(index + 1)))])])], 1)
  })], 2)])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notExist"
  }, [_c('p', [_vm._v("Le parcours que vous cherchez n'existe pas")]), _vm._v(" "), _c('back-btn')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b17d0e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParcoursIndexComponent.vue
// module id = 94
// module chunks = 0